import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Employee }   from 'Domain/Models';

const config = {
    model: Employee,
    baseRoute: '/admin/employee',
    singular: 'employee',
    plural: 'employees',
}

class EmployeeRepository extends BaseRepository<Employee, typeof config.singular, typeof config.plural> {

}

export default new EmployeeRepository(config);
